
import AppImage from "@/components/ui/AppImage";

export default function Footer() {
  return (
    <footer className="border-t border-white/5 bg-navy-950 py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          {/* Logo + Copyright */}
          <div className="flex flex-col items-center md:items-start gap-3">
            <AppImage
              src="/assets/images/logo-white-1-1772521738205.png"
              alt="BlueSea Marine Services white logo"
              width={160}
              height={62}
              className="h-10 w-auto object-contain opacity-90"
            />
            <p className="text-[13px] text-[#8BA3BC] font-medium">
              © 2026 Blue Sea Marine Services. All rights reserved.
            </p>
          </div>

          {/* Nav Links */}
          <div className="flex flex-wrap justify-center gap-x-8 gap-y-2 text-[13px] font-medium text-[#8BA3BC]">
            <a href="#about" className="hover:text-ocean-400 transition-colors">About</a>
            <a href="#services" className="hover:text-ocean-400 transition-colors">Services</a>
            <a href="#ports" className="hover:text-ocean-400 transition-colors">Ports</a>
            <a href="#testimonials" className="hover:text-ocean-400 transition-colors">Clients</a>
            <a href="#contact" className="hover:text-ocean-400 transition-colors">Contact</a>
            <span className="text-white/10">·</span>
            <a href="#" className="hover:text-ocean-400 transition-colors">Privacy Policy</a>
            <a href="#" className="hover:text-ocean-400 transition-colors">Terms</a>
          </div>

          {/* Social Icons */}
          <div className="flex items-center gap-4">
            <a
              href="https://wa.me/919821177666"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-[#8BA3BC] hover:text-white hover:border-ocean-500 hover:bg-ocean-500/10 transition-all"
              aria-label="WhatsApp"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
              </svg>
            </a>
            <a
              href="mailto:info@blueseamarine.in"
              className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-[#8BA3BC] hover:text-white hover:border-ocean-500 hover:bg-ocean-500/10 transition-all"
              aria-label="Email"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                <polyline points="22,6 12,13 2,6"/>
              </svg>
            </a>
            <a
              href="https://www.linkedin.com/company/blueseamarine"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-[#8BA3BC] hover:text-white hover:border-ocean-500 hover:bg-ocean-500/10 transition-all"
              aria-label="LinkedIn"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"/>
                <circle cx="4" cy="4" r="2"/>
              </svg>
            </a>
          </div>
        </div>

        {/* Bottom compliance note */}
        <div className="mt-10 pt-6 border-t border-white/5 text-center">
          <p className="text-[12px] text-[#8BA3BC]/60 leading-relaxed">
            Compliant with MARPOL & IMO Regulations · Established 2016, Mumbai, India · Operating across India, UAE, Bangladesh & Sri Lanka
          </p>
        </div>
      </div>
    </footer>
  );
}